import { PageBreadcrumb } from './page-breadcrumb';
import { PageContent } from './page-content';
import { PageHeader } from './page-header';
import { PageRoot } from './page-root';

/**
 * Entry point for Page.Root, Page.Breadcrumb, Page.Content, and Page.Header
 *
 * @since 8.15.0
 */
export const Page = {
  Breadcrumb: PageBreadcrumb,
  Content: PageContent,
  Header: PageHeader,
  Root: PageRoot,
};
